<ng-template #titleTpl>
  <!-- El nombre va en el título y la acción baja al subtítulo. Con el nombre en
       el subtítulo, el uppercase con tracking del theme inflaba un nombre largo
       hasta partirlo en dos renglones; el título no lleva uppercase y lo absorbe
       en una línea. De paso homologa con `solicitud-detalle-modal`, que ya
       identifica por nombre. -->
  @if (solicitud(); as sol) {
    <intelishs-page-header [title]="sol.empleadoNombre" [subtitle]="subtitulo()" />
  }
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="modalFooter"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (solicitud(); as sol) {
      <div class="modal-detail">
        <!-- Sin section-header: esta sección abre el modal y su línea quedaba a
             unos pixeles de la del encabezado, leyéndose como una raya doble.
             Las siguientes sí lo llevan —ahí sí separan bloques—. -->
        <div class="detalle-seccion">
          <!-- Las cuatro cifras del periodo en una sola fila: son la misma
               unidad —cuándo se pidió, para cuándo y cuánto— y separadas
               obligaban a saltar entre renglones para compararlas. Los campos
               de texto largo van debajo a ancho completo: con dos columnas,
               el puesto se partía en dos renglones. -->
          <div class="seccion-panel">
            <div class="grid-periodo">
              <app-detail-field
                [label]="paso() === 'director' ? 'Días hábiles' : 'Días solicitados'"
                layout="stacked"
                >{{ sol.diasSolicitados }}</app-detail-field
              >
              <app-detail-field label="Solicitada" layout="stacked">{{
                sol.fechaSolicitud | date: 'dd/MM/yyyy'
              }}</app-detail-field>
              <app-detail-field label="Fecha inicio" layout="stacked">{{
                sol.fechaInicio | date: 'dd/MM/yyyy'
              }}</app-detail-field>
              <app-detail-field label="Fecha fin" layout="stacked">{{
                sol.fechaFin | date: 'dd/MM/yyyy'
              }}</app-detail-field>
            </div>

            @if (sol.comentarios) {
              <app-detail-field label="Comentario del empleado" layout="stacked" [full]="true">
                {{ sol.comentarios }}
              </app-detail-field>
            }
            @if (paso() === 'rh' && sol.comentariosDirector) {
              <app-detail-field label="Comentario del director" layout="stacked" [full]="true">
                {{ sol.comentariosDirector }}
              </app-detail-field>
            }

            <!-- Área y dirección juntas (misma dimensión: dónde trabaja) y el
                 puesto aparte (qué hace). Antes iban "Área / Puesto", que
                 mezclaba las dos. Mismo agrupamiento que en las tablas. -->
            <app-detail-field label="Área / Dirección" layout="stacked" [full]="true">{{
              describirAdscripcion(sol)
            }}</app-detail-field>
            @if (paso() === 'director' && sol.puesto) {
              <app-detail-field label="Puesto" layout="stacked" [full]="true">{{
                sol.puesto
              }}</app-detail-field>
            }
          </div>

          <!-- Fuera de política: se avisa, no se bloquea. Fuera del panel para
               que no se lea como un campo más de la solicitud. -->
          @if (incumplePolitica()) {
            <div class="aviso aviso--warning">
              <nz-icon nzType="warning" />
              <span>
                No cumple la política de 2 semanas de anticipación. Si se aprueba, queda registrada
                como excepción.
              </span>
            </div>
          }
        </div>

        <!-- ── Impacto de la decisión ──────────────────────────────────
             El dato con el que se autoriza. Antes vivía en un banner verde
             (o naranja si daba negativo) al mismo nivel visual que el resto;
             ahora es un bloque propio con la cifra grande, igual que el
             resumen del modal de alta. -->
        @if (accion() === 'aprobar') {
          <div class="detalle-seccion">
            <intelishs-section-header title="Impacto en el saldo" />

            @if (loadingSaldo()) {
              <p class="impacto-cargando">
                <nz-icon nzType="loading" nzSpin />
                Calculando el saldo del empleado…
              </p>
            } @else if (saldoProyeccion(); as proj) {
              <div class="resumen" [class.resumen--negativo]="proj.esNegativo">
                <div class="resumen-total">
                  <span class="resumen-total-lbl">Le queda tras aprobar</span>
                  <span
                    class="resumen-total-val"
                    [class.resumen-total-val--negativo]="proj.esNegativo"
                  >
                    {{ proj.saldoFinal | number: '1.1-1' }} días
                  </span>
                </div>

                <div class="resumen-desglose">
                  <div class="resumen-row">
                    <span>Disponibles hoy</span>
                    <span class="resumen-row-val"
                      >{{ proj.disponiblesSinEsta | number: '1.1-1' }} días</span
                    >
                  </div>
                  <div class="resumen-row">
                    <span>Esta solicitud</span>
                    <span class="resumen-row-val">− {{ proj.diasSolicitados }} días</span>
                  </div>
                </div>

                @if (proj.esNegativo) {
                  <p class="resumen-nota resumen-nota--negativo">
                    Quedará en negativo. El saldo se compensa solo con los días que genere en los
                    próximos meses.
                  </p>
                }
              </div>
            }
          </div>
        }

        <div class="detalle-seccion">
          <intelishs-section-header title="Comentario para el empleado" />
          <textarea
            nz-input
            rows="2"
            placeholder="Opcional — el empleado lo verá en su solicitud"
            [ngModel]="comentarios()"
            (ngModelChange)="comentarios.set($event)"
          ></textarea>
          @if (paso() === 'director' && accion() === 'aprobar') {
            <p class="form-hint">Al aprobar, la solicitud pasa a revisión final de RH.</p>
          }
        </div>
      </div>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="sinay-outline-reset" (click)="cerrar()">Cancelar</button>
    <button
      nz-button
      class="btn-add"
      [nzDanger]="okDanger()"
      [nzLoading]="procesando()"
      (click)="confirmarAccion()"
    >
      {{ okText() }}
    </button>
  </ng-template>
</nz-modal>
